import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'

function ProgressiveImg({ placeholderSrc, src, ...props }) {
  const [imgSrc, setImgSrc] = useState(placeholderSrc || src)
  // const customClass=placeholderSrc && imgSrc === placeholderSrc ? styles.loading : styles.loaded
  const [customClass, setCustomClass] = useState(styles.loading)

  useEffect(() => {
    setCustomClass(placeholderSrc && imgSrc === placeholderSrc ? styles.loading : styles.loaded)
  }, [placeholderSrc, imgSrc])

  useEffect(() => {
    const img = new Image()
    img.src = src
    img.onload = () => {
      setImgSrc(src)
    }
  }, [src])

  const handleError = () => {
    setCustomClass(styles.loading)
  }

  return (
    <img
      onError={handleError}
      {...{ src: imgSrc, ...props }}
      className={`${styles.image} ${props.className} ${customClass}`}
    />
  )
}

export default ProgressiveImg
